export const CONTENT_TYPES = [
  'post',
  'caption',
  'short_post',
  'thread',
  'announcement',
  'article_teaser',
] as const;
export type ContentType = (typeof CONTENT_TYPES)[number];

export const CONTENT_GOALS = [
  'AWARENESS',
  'ACQUISITION',
  'ENGAGEMENT',
  'RETENTION',
  'REACTIVATION',
  'ANNOUNCEMENT',
  'TRAFFIC',
  'COMMUNITY',
] as const;
export type ContentGoal = (typeof CONTENT_GOALS)[number];

export const LANGUAGES = ['pl', 'en', 'de', 'fr', 'es', 'it', 'uk'] as const;
export type Language = (typeof LANGUAGES)[number];

export const AI_MODEL_TYPES = [
  'TEXT',
  'IMAGE',
  'VIDEO',
  'TTS',
  'EMBEDDING',
  'MULTIMODAL',
] as const;
export type AiModelType = (typeof AI_MODEL_TYPES)[number];

export const AI_PROVIDER_KEYS = [
  'mock',
  'workers-ai',
  'openrouter',
  'openai',
  'krea',
  'anthropic',
] as const;
export type AiProviderKey = (typeof AI_PROVIDER_KEYS)[number];

export const AUTOPILOT_LEVELS = [
  'OFF',
  'ASSISTED',
  'AUTO_GENERATE',
  'AUTO_SCHEDULE',
  'FULL_AUTOPILOT',
] as const;
export type AutopilotLevel = (typeof AUTOPILOT_LEVELS)[number];

export const PROMPT_CATEGORIES = [
  'SOCIAL_POST',
  'IMAGE',
  'VIDEO',
  'CONTENT_IDEA',
  'CONTENT_PLAN',
  'REWRITE',
  'QUALITY_CHECK',
  'BRAND_ANALYSIS',
] as const;
export type PromptCategory = (typeof PROMPT_CATEGORIES)[number];

export const ASSET_TYPES = [
  'IMAGE',
  'VIDEO',
  'THUMBNAIL',
  'LOGO',
  'BRAND_MATERIAL',
  'SOURCE_MEDIA',
  'OTHER',
] as const;
export type AssetType = (typeof ASSET_TYPES)[number];

export const SOURCE_TYPES = [
  'WEBSITE',
  'SUBPAGE',
  'RSS',
  'SITEMAP',
  'GAZETTE',
  'GAME_DESCRIPTION',
  'MANUAL_NOTE',
  'DOCUMENT',
  'PREVIOUS_POST',
] as const;
export type SourceType = (typeof SOURCE_TYPES)[number];

export const PUBLISH_JOB_STATUSES = [
  'PENDING',
  'RUNNING',
  'SUCCESS',
  'FAILED',
  'CANCELLED',
] as const;
export type PublishJobStatus = (typeof PUBLISH_JOB_STATUSES)[number];

export const GENERATION_STATUSES = [
  'PENDING',
  'RUNNING',
  'SUCCESS',
  'FAILED',
] as const;
export type GenerationStatus = (typeof GENERATION_STATUSES)[number];

export const ROLES = ['OWNER', 'ADMIN', 'EDITOR', 'REVIEWER', 'VIEWER'] as const;
export type Role = (typeof ROLES)[number];

export const AGENT_SCOPES = [
  'brands:read',
  'brand-context:read',
  'campaigns:read',
  'campaigns:write',
  'campaigns:submit',
  'content:read',
  'content:write',
  'assets:request',
  'analytics:read',
  'publish:request',
  'publish:execute',
  'agents:manage',
  'render:jobs:read',
  'render:jobs:update',
  'assets:read',
  'assets:write',
  'finance:run',
  'bloodcrimes-tv:broadcast',
  'wbo-tv:broadcast',
  'fbo-tv:broadcast',
  'wbo-tv-vertical:broadcast',
  'fbo-tv-vertical:broadcast',
  'nieboguard:media',
  'nieboguard-tv:broadcast',
] as const;
export type AgentScope = (typeof AGENT_SCOPES)[number];

export const AGENT_DEFAULT_SCOPES: AgentScope[] = [
  'brands:read',
  'brand-context:read',
  'campaigns:read',
  'campaigns:write',
  'campaigns:submit',
  'content:read',
  'content:write',
  'assets:request',
];

export const DEFAULT_LOCALE = 'pl';
export const DEFAULT_TIMEZONE = 'Europe/Warsaw';

/** Similarity threshold above which content is flagged as too similar. */
export const DEFAULT_SIMILARITY_THRESHOLD = 0.86;
